if (!customElements.get('age-verification-popup')) {
  class AgeVerificationPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.storageKey = `age-verification-${this.dataset.sectionId || this.id}`;
      this.testMode = this.dataset.testMode === 'true';
      this.storageDays = Number(this.dataset.storageDays || 30);

      this.content = this.querySelector('[data-age-verification-popup-content]');
      this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
      this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
      this.approveButton = this.querySelector('[data-age-verification-popup-approve-button]');
      this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
      this.dialog = this.querySelector('.age-verification-popup__dialog');

      this.bindEvents();

      if (Shopify.designMode) {
        this.open();
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        return;
      }

      if (this.testMode || !this.hasValidStorage()) {
        this.open();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.unlockScroll();
    }

    bindEvents = () => {
      this.onSectionSelect = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.open();
      };

      this.onSectionDeselect = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId && !this.testMode && this.hasValidStorage()) {
          this.close();
        }
      };

      this.onSectionLoad = (event) => {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        if (this.testMode) this.clearStorage();
        this.open();
        if (sessionStorage.getItem(`${this.storageKey}-second-view`)) {
          this.showDeclineContent();
        }
      };

      this.declineButton?.addEventListener('click', (event) => {
        event.preventDefault();
        this.showDeclineContent();
        if (Shopify.designMode) {
          sessionStorage.setItem(`${this.storageKey}-second-view`, '1');
        }
      });

      this.returnButton?.addEventListener('click', (event) => {
        event.preventDefault();
        this.hideDeclineContent();
        if (Shopify.designMode) {
          sessionStorage.removeItem(`${this.storageKey}-second-view`);
        }
      });

      this.approveButton?.addEventListener('click', (event) => {
        event.preventDefault();
        if (!this.testMode) this.setStorage();
        this.close();
      });
    };

    open() {
      this.hidden = false;
      this.lockScroll();
    }

    close() {
      this.hidden = true;
      this.unlockScroll();
      this.hideDeclineContent();
    }

    showDeclineContent() {
      this.content?.classList.remove('age-verification-popup__content--active');
      this.content?.classList.add('age-verification-popup__content--inactive');
      this.declineContent?.classList.remove('age-verification-popup__decline--inactive');
      this.declineContent?.classList.add('age-verification-popup__decline--active');
      if (this.declineContent) this.declineContent.hidden = false;
    }

    hideDeclineContent() {
      this.declineContent?.classList.add('age-verification-popup__decline--inactive');
      this.declineContent?.classList.remove('age-verification-popup__decline--active');
      this.content?.classList.remove('age-verification-popup__content--inactive');
      this.content?.classList.add('age-verification-popup__content--active');
      if (this.declineContent) this.declineContent.hidden = true;
    }

    lockScroll() {
      document.body.classList.add('age-verification-open');
    }

    unlockScroll() {
      document.body.classList.remove('age-verification-open');
    }

    hasValidStorage() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return false;
        const data = JSON.parse(raw);
        if (!data?.expires) return false;
        if (Date.now() > data.expires) {
          localStorage.removeItem(this.storageKey);
          return false;
        }
        return data.value === 'entered';
      } catch (error) {
        return false;
      }
    }

    setStorage() {
      try {
        const expires = Date.now() + this.storageDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(this.storageKey, JSON.stringify({ value: 'entered', expires }));
      } catch (error) {
        // Ignore storage failures (private mode, etc.)
      }
    }

    clearStorage() {
      try {
        localStorage.removeItem(this.storageKey);
      } catch (error) {
        // Ignore
      }
    }
  }

  customElements.define('age-verification-popup', AgeVerificationPopup);
}
